import { useLayoutEffect, useSyncExternalStore, type ReactNode } from "react";
import { isBackgroundRefreshPaused, subscribeBackgroundRefresh } from "../system/backgroundRefresh";
import { InteractionBlockContext } from "../system/interactionBlock";

/** Only desktop app actions are locked; native/HTML caption buttons remain outside this group. */
export function AppShellDesktopActions({ enabled = true, notifyBlocked, children }: {
  enabled?: boolean;
  notifyBlocked?: (blocked: boolean) => void;
  children: ReactNode;
}) {
  const paused = useSyncExternalStore(subscribeBackgroundRefresh, isBackgroundRefreshPaused, () => false);
  const blocked = enabled && paused;
  useLayoutEffect(() => {
    if (!enabled || !notifyBlocked) return;
    // Subscribe directly as well: native shortcuts must stop in the same commit as the overlay.
    const update = () => notifyBlocked(isBackgroundRefreshPaused());
    const unsubscribe = subscribeBackgroundRefresh(update);
    update();
    return () => { unsubscribe(); notifyBlocked(false); };
  }, [enabled, notifyBlocked]);
  return (
    <InteractionBlockContext.Provider value={blocked}>
      <div className="mu-desktop-actions" inert={blocked} aria-disabled={blocked || undefined}>
        {children}
      </div>
    </InteractionBlockContext.Provider>
  );
}
